import { readLocal, saveLocal } from './localStorageHelper';

export const saveNavigation = (s) => saveLocal('nwm-navigation', s);
export const getNavigation = () => readLocal('nwm-navigation', null);
